/**
 * SIGEX eGov Mobile launch links.
 * @see https://sigex.kz/support/developers/api-egov-basic/
 *
 * Standard format (same as Sapar): https://m.egov.kz/mobileSign/?link=<encoded inner URL>
 */

function parseLinkQueryParam(queryPart: string): string | null {
  const key = 'link=';
  const idx = queryPart.indexOf(key);
  if (idx === -1) return null;
  let value = queryPart.slice(idx + key.length);
  if (value.includes('%')) {
    try {
      value = decodeURIComponent(value);
    } catch {
      /* keep raw */
    }
  }
  return value || null;
}

export function extractInnerSigexLink(link: string): string | null {
  const trimmed = link.trim();

  if (trimmed.startsWith('egovmobile://')) {
    const rest = trimmed.slice('egovmobile://'.length);
    const qIdx = rest.indexOf('?');
    if (qIdx === -1) return null;
    return parseLinkQueryParam(rest.slice(qIdx + 1));
  }

  try {
    const url = new URL(trimmed);
    if (url.hostname === 'm.egov.kz') {
      const query = url.search.startsWith('?') ? url.search.slice(1) : url.search;
      return parseLinkQueryParam(query);
    }
  } catch {
    /* ignore */
  }

  return null;
}

/** https://m.egov.kz/mobileSign/?link=... — opens eGov Mobile via Universal Link. */
export function buildMEgovHttpsLink(innerLink: string): string {
  return `https://m.egov.kz/mobileSign/?link=${encodeURIComponent(innerLink)}`;
}

export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export function isAndroidDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

export function isMobileDevice(): boolean {
  return isIosDevice() || isAndroidDevice();
}

/**
 * href for <a> — user must tap manually (required on iOS).
 * Always https://m.egov.kz/mobileSign/?link=... (SIGEX / Sapar format).
 */
export function resolveEgovLaunchHref(link: string | null | undefined): string | null {
  if (!link) return null;
  const trimmed = link.trim();
  const inner = extractInnerSigexLink(trimmed);
  if (inner) {
    return buildMEgovHttpsLink(inner);
  }
  return trimmed;
}

/** @deprecated use resolveEgovLaunchHref */
export function normalizeEgovMobileLaunchLink(link: string | null | undefined): string | null {
  return resolveEgovLaunchHref(link);
}
